import { TableCondition } from 'cadenza/conditions/table-condition/table-condition';
import { TreeConditionApi } from 'cadenza/api-client/conditions/tree-condition-api';
import { errorAlert } from 'cadenza/alert';
import { logger } from 'cadenza/utils/logging';
import { AbortError } from 'cadenza/api-client/abort-controller/abort-error';

import i18n from './messages.properties';

const name = 'd-tree-condition';

export class TreeCondition extends TableCondition {

  _treeConfiguration;
  _allowExcludeValues;
  _filterIdColumns;

  constructor ({
    treeConfiguration,
    values,
    allowExcludeValues,
    excludeValues,
    maxSelection,
    columnsConfigSupplier,
    conditionApiSupplier = configObject => new TreeConditionApi(configObject)
  } = {}) {
    super({
      values,
      allowExcludeValues,
      excludeValues,
      maxSelection,
      conditionApiSupplier,
      columnsConfigSupplier
    });
    this._treeConfiguration = treeConfiguration;
  }

  connectedCallback () {
    const data = this.previousElementSibling.value;
    this._filterIdColumns = !data; // for workbook we do not have a way to hide keyAttribute and parentAttribute, so we got them from backend and we need to filter them out here
    super.connectedCallback();
    this.classList.add(name);
    this._treeConfiguration = this._treeConfiguration || data.treeConfiguration;
  }

  showDialog () {
    return import(/* webpackChunkName: "tree-condition-modal" */ './tree-condition-modal/tree-condition-modal')
      .then(({ TreeConditionModal }) => {
        const selectedItemIds = (this.value ?? []).map(row => row.id);
        const dialog = new TreeConditionModal({
          selectedItemIds,
          title: this.conditionLabel,
          conditionApi: this.conditionApi,
          treeConfiguration: this._treeConfiguration,
          maxSelection: this.getAttribute('max-selection'),
          allowExcludeValues: this.allowExcludeValues,
          excludeValues: this.excludeValues,
          filterIdColumns: this._filterIdColumns
        });
        dialog.addEventListener('close', () => {
          dialog.remove();
          if (dialog.returnValue) {
            this.value = dialog.returnValue.selectedItems;
            if (this.allowExcludeValues) {
              this.excludeValues = dialog.returnValue.excludeValues;
            }
            this.onConditionChange();
          }
        });
        document.body.appendChild(dialog);
        dialog.showModal();
      }).catch((e) => {
        if (!(e instanceof AbortError)) {
          logger.error('exception in tree condition showDialog:', e);
          errorAlert(i18n('error.dialog.title'), i18n('error.dialog.message'));
        }
      });
  }

  createRowConverter () {
    if (this._filterIdColumns) {
      return row => {
        return formatLabelWithoutIdColumns(
          row.formatted,
          this._treeConfiguration.keyAttributeIndex,
          this._treeConfiguration.parentAttributeIndex
        );
      };
    } else {
      return super.createRowConverter();
    }
  }

  prepareRows (rows) {
    if (this._filterIdColumns) {
      const preparedRows = super.prepareRows(rows);
      return preparedRows.map(row => {
        return {
          ...row,
          text: formatLabelWithoutIdColumns(
            row.values,
            this._treeConfiguration.keyAttributeIndex,
            this._treeConfiguration.parentAttributeIndex
          )
        };
      });
    }
    return super.prepareRows(rows);
  }

}

customElements.define(name, TreeCondition);

export function formatLabelWithoutIdColumns (rowValues, keyAttributeIndex, parentAttributeIndex) {
  return rowValues
    .map(value => typeof value === 'string' ? value.trim() : value)
    .filter((value, index) => !!value && index !== keyAttributeIndex && index !== parentAttributeIndex)
    .join(', ');
}
